import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { DocumentApprovalType } from 'types/documentos'
import { DocumentStatus } from '../sidebars/DetailsSidebar'

export interface StatusItem {
  label: string
  value: string | number
}

interface DocumentStatusSelectProps {
  document: DocumentApprovalType
  handlerChangeStatus: (document: DocumentApprovalType, status: DocumentStatus) => void
  statusValue: (status: string, id_corcc080: number) => string | number
  LIST_DOCUMENT_STATUS_SELECT: StatusItem[]
  checkIfDocumentToDelete: (id: number) => boolean
  proposalStatus?: string
}

const DocumentStatusSelect = ({
  document,
  handlerChangeStatus,
  statusValue,
  LIST_DOCUMENT_STATUS_SELECT,
  checkIfDocumentToDelete,
  proposalStatus
}: DocumentStatusSelectProps) => {
  return (
    <FormControl>
      <InputLabel id="status-select-label">Status</InputLabel>
      <Select
        labelId="status-select-label"
        label="Status"
        value={statusValue(document.st_status, document.id_corcc080)}
        className="w-[350px]"
        onChange={(event) => {
          const value = event.target.value
          handlerChangeStatus(document, value as DocumentStatus)
        }}
        disabled={
          document.id_corcc080 === 0 ||
          checkIfDocumentToDelete(document.id_corcc080) ||
          proposalStatus === 'A'
        }
      >
        {LIST_DOCUMENT_STATUS_SELECT.map((status, index) => {
          if (document.id_corcc080 !== 0 && status.value === 'P') {
            return null
          }
          return (
            <MenuItem key={index} value={status.value}>
              {status.label}
            </MenuItem>
          )
        })}
      </Select>
    </FormControl>
  )
}

export default DocumentStatusSelect
